import * as Sentry from '@sentry/react';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';
import saveData from '../../../utils/saveData';
import { useEffect } from 'react';
import type { AuthTokenType } from '../../types/UserType';

interface AuthTokenResponse {
  user: AuthTokenType;
}

export default function useRefreshJwtQuery() {
  const tokenQuery = useQuery<AuthTokenResponse, Error, AuthTokenType>(
    ['refreshJwt'],
    () => queryGet('/api/v1/auth_token/refresh_jwt'),
    {
      select: (data) => data.user,
      cacheTime: 60 * 1000 * 60 * 24,
      staleTime: 60 * 1000 * 60 * 24
    }
  );

  useEffect(() => {
    if (tokenQuery.data?.jwt) {
      saveData('token', JSON.stringify(tokenQuery.data?.jwt));
    }
  }, [tokenQuery.data?.jwt]);

  if (!isEmpty(tokenQuery.data)) {
    Sentry.setUser({
      id: tokenQuery.data.userId,
      email: tokenQuery.data.email
    });
  }

  return tokenQuery;
}
